import React, { Fragment } from 'react';

import withPageComponents from '../../page/components/with-page-components';
import { Helpers } from '../../core/src/helpers';
import Link from '../../shared/components/hyperlink';
import IntelBadgeContainer from './badge-container';
import { StaticHtml } from '../../ui/components/static-content';

import '../css/coming-soon.less';

const COMING_SOON_LINKS = [
    {
        name: 'Laptops',
        destination: '/slp/weekly-deals/laptops',
    },
    {
        name: 'Desktops',
        destination: '/slp/weekly-deals/desktops',
    },
    {
        name: 'Printers',
        destination: '/slp/weekly-deals/printers',
    },
    {
        name: 'Monitors',
        destination: '/slp/weekly-deals/monitors',
    },
    {
        name: 'Accessories',
        destination: '/slp/weekly-deals/accessories',
    },
    {
        name: 'Business',
        destination: '/slp/weekly-smb-deals',
    },
];

class ComingSoon extends React.Component {
    render() {
        const { comingSoonLinks, intelBadge, comingSoonContent, comingSoon } = this.props;
        const { enabled, content: localContent, css: localCSS, overrideGlobalContent } = comingSoon || {};

        //only show page specific coming soon content when page is flagged for coming soon
        if ((comingSoonContent && comingSoonContent.content) || (enabled && localContent)) {
            const { css, content } = comingSoonContent || {};
            return (
                <>
                    {!overrideGlobalContent && (
                        <StaticHtml className={'coming-soon-container'} css={css} content={content} />
                    )}
                    {enabled && (
                        <StaticHtml className={'coming-soon-container'} css={localCSS} content={localContent} />
                    )}
                </>
            );
        }
        return (
            <Fragment>
                {intelBadge ? (
                    <div className="intel-badge-container">
                        <IntelBadgeContainer />
                    </div>
                ) : null}
                <div className="shop-more-container">
                    <h1>Shop Weekly Deals:</h1>
                    <div className="pg-list">
                        {comingSoonLinks.map((link, i) => {
                            return (
                                <Link to={`${link.destination.toLowerCase()}`} className="pg-list-item" key={i}>
                                    <div className={`hp-icon ${link.name.toLowerCase().replace(' ', '-')}`}>
                                        <p>{link.name}</p>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </Fragment>
        );
    }
}

ComingSoon.defaultProps = {
    comingSoonLinks: COMING_SOON_LINKS,
};

export default withPageComponents(
    props => {
        return <ComingSoon {...props} />;
    },
    { components: ['comingSoonContent', 'comingSoon'] }
);
